export const SET_AUTH = 'SET_AUTH'
export const SET_PRODUCTINFO = 'SET_PRODUCTINFO'
export const LOG_OUT = 'LOG_OUT'

export default {
  SET_AUTH,
  SET_PRODUCTINFO,
  LOG_OUT
}
